export default class GroupsAPIService {
  constructor($http, appSettings) {
    'ngInject';
    this.$http = $http;
    this.appSettings = appSettings;
    this.groupEndpointUrl = `${this.appSettings.InReachApiEndpoint}access/operators`;
  }
  sendInvite(group) {
    return this.$http.post(this.groupEndpointUrl + '/invite', group);
  }
}
